import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';
import React from 'react';
import { useMediaExplorer } from 'modules/media/services/hooks/useMediaExplorer';
import MediaManagerGalleryMode from '../Dashboard/LibraryList/GalleryMode';
import MediaManagerListMode from '../Dashboard/LibraryList/ListMode';
import MediaManagerGridMode from '../Dashboard/LibraryList/GridMode';
import styled from 'styled-components';
import useViewMode from 'modules/media/services/hooks/useViewMode';

const MediaFolderDetailPage = () => {
  const [data, mutate] = useGetManageLibrary();
  const { mode: viewMode, setViewMode } = useViewMode();

  const { items, pathStack, openFolder, onBack, currentPath } = useMediaExplorer(data, mutate);

  return (
    <Container>
      <MediaManagerGalleryMode
        viewMode={viewMode}
        onChangeViewMode={setViewMode}
        path={pathStack}
        onBack={onBack}
        currentPath={currentPath}
      />
      {viewMode === 'list' ? (
        <MediaManagerListMode items={items} onOpenFolder={openFolder} currentPath={currentPath} />
      ) : (
        <MediaManagerGridMode items={items} onOpenFolder={openFolder} currentPath={currentPath} />
      )}
    </Container>
  );
};

export default MediaFolderDetailPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;
